module.exports = __webpack_public_path__ + "img/x6.9690211f.jpg";